import { useDailyLowestPrices } from "@/actions/hooks/useDailyLowestPrices.ts";
import { DayPickerButton } from "@/components/Inputs/RangePicker/components/DayPickerButton/DayPickerButton.tsx";
import { useRangePickerDayPickerProps } from "@/components/Inputs/RangePicker/hooks/useRangePickerDayPickerProps.tsx";
import { useRangePickerOutsideInteractions } from "@/components/Inputs/RangePicker/hooks/useRangePickerOutsideInteractions.ts";
import { useRangePickerScrollBehavior } from "@/components/Inputs/RangePicker/hooks/useRangePickerScrollBehavior.ts";
import { RangePickerProps } from "@/components/Inputs/RangePicker/RangePickerProps.ts";
import { useMemo, useRef, useState } from "react";
import { DayPicker } from "react-day-picker";

// Persisted dates rehydrate from localStorage as ISO strings, so coerce to a real Date.
const toDate = (value: Date | string | null | undefined): Date | null => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const RangePicker = (props: RangePickerProps) => {
  const [hideDatePicker, setHideDatePicker] = useState(true);
  const startDate = useMemo(() => toDate(props.startDate), [props.startDate]);
  const endDate = useMemo(() => toDate(props.endDate), [props.endDate]);
  const [displayedMonth, setDisplayedMonth] = useState<Date>(() => startDate ?? new Date());
  const { onChange } = props;
  const dayPickerRef = useRef<HTMLDivElement>(null);

  useRangePickerOutsideInteractions(dayPickerRef, setHideDatePicker);
  useRangePickerScrollBehavior(hideDatePicker);
  useDailyLowestPrices({ displayedMonth });

  const dayPickerProps = useRangePickerDayPickerProps({
    startDate,
    endDate,
    onChange,
    filterDate: props.filterDate,
    setHideDatePicker,
    onMonthChange: setDisplayedMonth,
  });

  return (
    <div
      className={`c-be-range-picker-wrapper ${!hideDatePicker ? "c-be-range-picker-wrapper--open" : ""}`}
      ref={dayPickerRef}
    >
      <DayPickerButton
        disabled={!!props.disabled}
        setHideDatePicker={setHideDatePicker}
        startDate={startDate}
        endDate={endDate}
        prefixIcon={props.prefixIcon}
      />
      <div className={`${hideDatePicker ? "daypicker-popup_hide" : "daypicker-popup"}`}>
        <DayPicker {...dayPickerProps} />
      </div>
    </div>
  );
};
